// eslint-disable-next-line import/no-cycle
import loopFieldConfig from '@/components/template-builder/config/fields/loop-config';
// eslint-disable-next-line import/no-cycle
import getLoopConfiguration from '@/components/template-builder/getters/loop-configuration';
// eslint-disable-next-line import/no-cycle
import setLoopConfiguration from '@/components/template-builder/setters/loop-configuration';

/**
 * Get loop field configuration
 * @param selector - CSS selector for the element
 * @returns Field configuration object
 */
const getLoopField = (selector: string) => ({
  ...loopFieldConfig,
  label: 'templateBuilder.loop.title',
  selector,
  properties: [{ name: 's-collection', getter: getLoopConfiguration, setters: [setLoopConfiguration] }],
});

export default getLoopField;
